import React from 'react';

export interface SliderProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  className?: string;
  disabled?: boolean;
}

export function Slider({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  className = '',
  disabled = false
}: SliderProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(Number(e.target.value));
  };

  return (
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      className={`
        w-full h-2 bg-dark-border rounded-lg appearance-none cursor-pointer
        slider-thumb:appearance-none slider-thumb:w-4 slider-thumb:h-4
        slider-thumb:rounded-full slider-thumb:bg-brand-500
        slider-thumb:cursor-pointer slider-thumb:border-2 slider-thumb:border-white
        hover:slider-thumb:bg-brand-400
        disabled:opacity-50 disabled:cursor-not-allowed
        ${className}
      `}
      style={{
        background: `linear-gradient(to right,
          rgb(var(--color-brand-500)) 0%,
          rgb(var(--color-brand-500)) ${((value - min) / (max - min)) * 100}%,
          rgb(var(--color-dark-border)) ${((value - min) / (max - min)) * 100}%,
          rgb(var(--color-dark-border)) 100%)`
      }}
    />
  );
}

export default Slider;
